/* Video seridi - ORTADA BIR BUYUK, iki yanda ikiser kart; SONSUZ doner.
   - Merkeze en yakin kart `.is-merkez` alir: buyur, netlesir ve YALNIZ O
     OYNAR. Digerleri durur - bes videoyu birden kod cozmek mobilde isinma
     ve takilma uretiyor, ustelik odak zaten tek yerde.
   - Sonsuzluk KLONLA: liste uc kez basilir, serit ortadaki kumede durur.
     Kenara yaklasinca konum bir kume kadar SESSIZCE kaydirilir; gorsel
     olarak hicbir sey olmaz ama iki yanda her zaman kart bulunur, bos
     taraf olusmaz.
   - Klonlar ekran okuyucuya ve klavyeye KAPALI (aria-hidden + inert),
     yoksa her video uc kez okunur ve sekme sirasi uce katlanir.
   - Kaynak (`src`) basta verilmez, kart yaklasinca yuklenir.
   - `prefers-reduced-motion` aciksa otomatik oynatma yok. */
(function () {
  'use strict';

  var azHareket = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function kaynakVer(video) {
    if (video && video.dataset.src && !video.src) video.src = video.dataset.src;
  }

  /* Tema editoru mu? Editorde serit SADE calisir - sebebi asagida. */
  var editor = !!(window.Shopify && window.Shopify.designMode);

  function kur(ray) {
    /* TEKRAR KURULUM KORUMASI.
       Yoksa `basla()` ile `shopify:section:load` ayni ray uzerinde iki kez
       calisabiliyor; her kosuda klonlar yeniden ekleniyor (6 -> 18 -> 54
       kart) ve dinleyiciler ustuste biniyor. Editorde bolum sik sik
       yeniden ciziliyor, orada katlanarak buyuyor. */
    if (ray.dataset.hazir === '1') return;
    ray.dataset.hazir = '1';

    var otomatik = ray.dataset.otomatik === 'true' && !azHareket.matches;
    var ozgun = Array.prototype.slice.call(ray.querySelectorAll('.vserit__kart'));
    if (!ozgun.length) return;

    /* --- sonsuzluk icin klonlar ---
       Dort kartin altinda klonlamak anlamsiz: hepsi zaten ayni anda
       gorunur, donecek bir sey yok.

       EDITORDE KLON YOK (musteri bildirimi 2026-10-22: "video alanini
       duzenlemeye tikladigimda yuklu videolar buga girmis gibi hareket
       ediyorlar"). Iki sebep:
       1) Klon `block.shopify_attributes`i da kopyaliyordu, yani AYNI blok
          kimligi DOM'da uc kez bulunuyordu. Editor bir bloga tiklayinca
          hangi kopyayi secip hangisine kaydiracagini bilemiyor, secim
          cercevesi kopyalar arasinda ziplıyordu.
       2) Editor secili bloga `scrollIntoView` yapiyor; bu kenara yaklasinca
          bizim `sarmala()` bir kume kadar atliyor, editor tekrar kaydiriyor
          -> karsilikli itisme, kartlar titriyor.
       Editorde serit duz bir kaydirici olur: her blok = TEK kart, secim
       net, atlama yok. Magazada (editor disinda) sonsuz dongu aynen devam. */
    var dongu = !editor && ozgun.length >= 4;
    if (dongu) {
      var oncesi = document.createDocumentFragment();
      var sonrasi = document.createDocumentFragment();
      ozgun.forEach(function (k) {
        [oncesi, sonrasi].forEach(function (hedef) {
          var kl = k.cloneNode(true);
          kl.setAttribute('aria-hidden', 'true');
          kl.setAttribute('inert', '');
          kl.dataset.klon = '1';
          /* Editor nitelikleri klonda KALMAZ - ayni blok kimligi birden
             fazla dugumde bulunmasin. Magazada da gereksiz. */
          kl.removeAttribute('data-shopify-editor-block');
          kl.removeAttribute('id');
          hedef.appendChild(kl);
        });
      });
      ray.insertBefore(oncesi, ozgun[0]);
      ray.appendChild(sonrasi);
    }

    var kartlar = Array.prototype.slice.call(ray.querySelectorAll('.vserit__kart'));
    var merkezKart = null;

    function bosluk() {
      var stil = getComputedStyle(ray);
      return parseFloat(stil.columnGap || stil.gap || '0') || 0;
    }

    /* `offsetWidth` DONUSUMDEN etkilenmez; kartlarda `transform: scale`
       oldugu icin `getBoundingClientRect` yanlis olcu verir. */
    function adim() {
      var k = kartlar[0];
      return k ? k.offsetWidth + bosluk() : 240;
    }

    function kumeGenisligi() {
      return ozgun.length * adim();
    }

    function durdur(kart) {
      var v = kart.querySelector('.vserit__video');
      if (v && !v.paused) v.pause();
      kart.classList.remove('oynuyor');
    }

    function oynat(kart) {
      var v = kart.querySelector('.vserit__video');
      if (!v) return;
      kaynakVer(v);
      // play() soz dondurur ve reddedilebilir; yakalanmazsa konsola
      // islenmemis hata duser.
      var s = v.play();
      if (s && typeof s.catch === 'function') {
        s.catch(function () { kart.classList.remove('oynuyor'); });
      }
      kart.classList.add('oynuyor');
    }

    function sustur(kart) {
      var v = kart.querySelector('.vserit__video');
      var b = kart.querySelector('[data-ses]');
      if (v) v.muted = true;
      if (b) {
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', 'Sesi ac');
      }
    }

    function gorusAlaninda() {
      var r = ray.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || 0);
    }

    /* Merkez, RAYIN gorunen orta noktasina gore hesaplanir - ekranin
       degil. Bolum sayfanin kenarina yaslandiginda ikisi ayrisiyor. */
    function merkeziBul() {
      var r = ray.getBoundingClientRect();
      var orta = r.left + r.width / 2;
      var enYakin = null, enKucuk = Infinity;
      kartlar.forEach(function (k) {
        var kr = k.getBoundingClientRect();
        var fark = Math.abs(kr.left + kr.width / 2 - orta);
        if (fark < enKucuk) { enKucuk = fark; enYakin = k; }
      });
      if (!enYakin || enYakin === merkezKart) return;

      if (merkezKart) {
        merkezKart.classList.remove('is-merkez');
        durdur(merkezKart);
        sustur(merkezKart);          // odak degisince ses de kapanir
      }
      merkezKart = enYakin;
      merkezKart.classList.add('is-merkez');
      kaynakVer(merkezKart.querySelector('.vserit__video'));
      // Komsularin kaynagini da ver: odaga girdiklerinde ilk kare beklemesin.
      var i = kartlar.indexOf(merkezKart);
      [kartlar[i - 1], kartlar[i + 1]].forEach(function (k) {
        if (k) kaynakVer(k.querySelector('.vserit__video'));
      });
      if (otomatik && gorusAlaninda()) oynat(merkezKart);
    }

    /* Kenara yaklasinca bir kume kadar sessizce atla. Esik kenardan UZAK
       (yarim kume): kullanici atlama anini gormesin. */
    function sarmala() {
      if (!dongu) return;
      var kume = kumeGenisligi();
      if (!kume) return;
      if (ray.scrollLeft < kume * 0.5) ray.scrollLeft += kume;
      else if (ray.scrollLeft > kume * 1.5) ray.scrollLeft -= kume;
    }

    /* --- oklar --- */
    var geri = ray.parentElement.querySelector('[data-vserit-geri]');
    var ileri = ray.parentElement.querySelector('[data-vserit-ileri]');

    function okDurum() {
      if (!geri || !ileri) return;
      if (dongu) {
        // Sonsuz seritte ok hic pasif olmaz - her yone gidilebilir.
        geri.disabled = false;
        ileri.disabled = false;
        return;
      }
      var son = ray.scrollWidth - ray.clientWidth;
      geri.disabled = ray.scrollLeft <= 2;
      ileri.disabled = ray.scrollLeft >= son - 2;
    }

    function kaydir(yon) {
      // ONCE sarmala, SONRA kaydir: atlama yumusak hareketin ortasinda
      // olursa hareket yarida kesilir ve ziplar gibi gorunur.
      sarmala();

      /* TAM BIR VIDEO kaydir. `scrollBy(kart genisligi)` yeterli DEGIL:
         `scroll-snap-type: x mandatory` acikken tarayici hareketin
         bittigi noktaya en yakin durak noktasina yapisiyor; adim bir
         durak noktasinin ortasini gecerse IKI kart birden kayiyor.
         Bunun yerine komsu kart ACIKCA ortalaniyor - kac piksel gerektigi
         o anki yerlesimden olculuyor, tahmin edilmiyor.

         `getBoundingClientRect` burada guvenli: kartlarda `transform:
         scale` var ama `transform-origin: center`, yani olcek elemanin
         YATAY MERKEZINI degistirmiyor. */
      var i = kartlar.indexOf(merkezKart);
      var hedef = (i >= 0) ? kartlar[i + yon] : null;
      if (!hedef) {
        ray.scrollBy({ left: yon * adim(), behavior: 'smooth' });
        return;
      }
      var r = ray.getBoundingClientRect();
      var hr = hedef.getBoundingClientRect();
      ray.scrollBy({
        left: (hr.left + hr.width / 2) - (r.left + r.width / 2),
        behavior: 'smooth'
      });
    }

    if (geri) geri.addEventListener('click', function () { kaydir(-1); });
    if (ileri) ileri.addEventListener('click', function () { kaydir(1); });

    var bekliyor = false;
    ray.addEventListener('scroll', function () {
      if (bekliyor) return;
      bekliyor = true;
      requestAnimationFrame(function () {
        bekliyor = false;
        merkeziBul();
        okDurum();
      });
    }, { passive: true });

    window.addEventListener('resize', function () { merkeziBul(); okDurum(); });

    /* Sarmalama yalniz hareket BITTIGINDE: kaydirma surerken konumu
       degistirmek hareketi keser. */
    if ('onscrollend' in window) {
      ray.addEventListener('scrollend', sarmala);
    }
    ['touchend', 'pointerup'].forEach(function (olay) {
      ray.addEventListener(olay, function () { setTimeout(sarmala, 220); }, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (girisler) {
        girisler.forEach(function (g) {
          if (g.isIntersecting) {
            if (otomatik && merkezKart) oynat(merkezKart);
          } else if (merkezKart) {
            durdur(merkezKart);
          }
        });
      }, { threshold: 0.25 }).observe(ray);
    }

    ray.addEventListener('click', function (e) {
      var sesBtn = e.target.closest('[data-ses]');
      if (sesBtn) {
        e.preventDefault();
        var kart = sesBtn.closest('.vserit__kart');
        var video = kart.querySelector('.vserit__video');
        var acilacak = video.muted;
        kartlar.forEach(sustur);     // ayni anda iki ses calmasin
        if (acilacak) {
          video.muted = false;
          sesBtn.setAttribute('aria-pressed', 'true');
          sesBtn.setAttribute('aria-label', 'Sesi kapat');
          oynat(kart);
        }
        return;
      }

      var oynatBtn = e.target.closest('[data-oynat]');
      if (oynatBtn) {
        e.preventDefault();
        var k2 = oynatBtn.closest('.vserit__kart');
        var v2 = k2.querySelector('.vserit__video');
        if (v2 && v2.paused) oynat(k2); else durdur(k2);
        return;
      }

      /* Baslik baglantisi: urune gitsin, karismayalim.
         Baslik kutunun DISINDA duruyor (`.vserit__kutu` kardesi), yani
         asagidaki dallara zaten dusmez; yine de acikca gecelim. */
      if (e.target.closest('.vserit__kart-baglanti')) return;

      /* Yandaki karta tiklanirsa ONCE ortaya getir - kullanici zaten
         "sunu izleyeyim" diyor, urune gitmek istemiyor. */
      var kart3 = e.target.closest('.vserit__kart');
      if (kart3 && kart3 !== merkezKart) {
        e.preventDefault();
        kart3.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        return;
      }

      /* ORTADAKI KARTIN VIDEOSUNA TIKLAMA = OYNAT / DURDUR (2026-10-23).
         Onceden kutunun tamami urun baglantisiydi ve "videoyu izleyeyim"
         diye tiklayan herkes urun sayfasina gidiyordu (musteri bildirimi).
         Baglanti artik basligin uzerinde; kutu videonun kendisi.
         Yalniz `.vserit__kutu` icindeki tiklama sayilir - baslik ve kart
         alti disarida kalir. */
      if (kart3 && kart3 === merkezKart && e.target.closest('.vserit__kutu')) {
        var v3 = kart3.querySelector('.vserit__video');
        if (v3) {
          e.preventDefault();
          if (v3.paused) oynat(kart3); else durdur(kart3);
        }
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) kartlar.forEach(durdur);
      else if (otomatik && merkezKart && gorusAlaninda()) oynat(merkezKart);
    });

    /* ACILIS: ortadaki kumeye git. Klonlar sayesinde solda da sagda da
       kart vardir - hicbir yanda bosluk olusmaz. */
    function baslangic() {
      if (dongu) {
        ray.scrollLeft = kumeGenisligi();
      } else if (kartlar.length >= 3) {
        var r0 = ray.getBoundingClientRect();
        var k0 = kartlar[1].getBoundingClientRect();
        ray.scrollLeft += (k0.left + k0.width / 2) - (r0.left + r0.width / 2);
      }
      merkeziBul();
      okDurum();
    }

    // Kart genislikleri yerlesmeden olcum yanlis cikar; bir kare bekle.
    requestAnimationFrame(baslangic);

    /* --- TEMA EDITORU ---
       Editorde bir bloga tiklaninca o kart ortaya getirilir. Bunu BIZ
       yapmazsak editor kendi `scrollIntoView`unu calistirir; o da yatay
       kaydiricida beklenmedik yerlere atlayabiliyor. Kendimiz ortalayinca
       hareket tek ve ongorulebilir oluyor.
       `sarmala` burada CAGRILMAZ - editorde zaten klon yok. */
    if (editor) {
      /* KARTIN KENDISINI alir, kimlikle ARAMAZ.
         Once kimlikle ariyordu ve calismiyordu: `data-shopify-editor-block`
         yalnizca editorde SUNUCU tarafindan basiliyor, onizlemede yok;
         kimlik bos kalinca arama bos donup secim sessizce yutuluyordu
         (olculdu 2026-10-22: "Honda PCX 125" secildi, merkez degismedi).
         Olay zaten kartin icinden kabariyor - eleman elimizde. */
      ray.__vseritSec = function (kart) {
        if (!kart || kart.closest('[data-vserit]') !== ray) return;
        var r = ray.getBoundingClientRect();
        var kr = kart.getBoundingClientRect();
        ray.scrollBy({
          left: (kr.left + kr.width / 2) - (r.left + r.width / 2),
          behavior: 'smooth'
        });
        setTimeout(function () { merkeziBul(); okDurum(); }, 320);
      };
      ray.__vseritDurdur = function () { kartlar.forEach(durdur); };
    }
  }

  function basla() {
    document.querySelectorAll('[data-vserit]').forEach(kur);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', basla);
  } else {
    basla();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var ray = e.target.querySelector('[data-vserit]');
    if (ray) kur(ray);
  });

  /* Bolum DOM'dan cikarken bayragi temizle. Shopify ayni bolumu kaldirip
     yeniden basabiliyor; bayrak kalirsa yeni kopya hic kurulmaz ve serit
     olu gorunur. */
  document.addEventListener('shopify:section:unload', function (e) {
    var ray = e.target.querySelector && e.target.querySelector('[data-vserit]');
    if (!ray) return;
    if (ray.__vseritDurdur) ray.__vseritDurdur();
    ray.dataset.hazir = '';
  });

  /* Blok secimi: ilgili karti ortala.
     `e.target` secilen blok dugumudur; kartin KENDISI ya da icinde bir
     eleman olabilir, ikisini de `closest` ile karta cikariyoruz. */
  document.addEventListener('shopify:block:select', function (e) {
    var hedef = e.target;
    if (!hedef || !hedef.closest) return;
    var kart = hedef.closest('.vserit__kart');
    if (!kart) return;
    var ray = kart.closest('[data-vserit]');
    if (ray && ray.__vseritSec) ray.__vseritSec(kart);
  });
})();
